import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import './components/common/directives';
import 'tailwindcss/tailwind.css';
import {Icon} from '@v2icons/utils';
import {getStorage} from './utils/index';

// 引入eIconPicker
import eIconPicker from 'e-icon-picker';
import 'e-icon-picker/lib/index.css'; // 基本样式，包含基本图标
import 'font-awesome/css/font-awesome.min.css'; //font-awesome 图标库
import 'element-ui/lib/theme-chalk/icon.css'; //element-ui

// iconfont导入到eIconPicker
import '@/assets/css/iconfontbak/iconfont.css';
import { analyzingIconForIconfont } from 'e-icon-picker';
import iconfontJson from '@/assets/css/iconfontbak/iconfont.json';
let iconFontList = analyzingIconForIconfont(iconfontJson)

// import { Message } from 'element-ui';
import VueSocketIO from 'vue-socket.io';
import SocketIO from 'socket.io-client';
import Print from 'vue-print-nb'; //引入

//全局删除增加图标
Vue.use(eIconPicker, {
    FontAwesome: false,
    ElementUI: false,
    eIcon: false, //自带的图标，来自阿里妈妈
    addIconList: iconFontList.list,
    removeIconList: [],
    zIndex: 3100 //选择器弹层的最低层,全局配置
});
 
Vue.component('Icon', Icon);
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Print); //注册
// Vue.component(Message);
// Vue.prototype.$message = Message;

import moment from 'moment';
Vue.prototype.$moment = moment;


let sysInfo;
setTimeout(()=>{
    sysInfo = store.state.sysInfo.sysName
},200)

// 使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    document.title = `${to.meta.title} - ${sysInfo || '后台管理系统'}`;
    const token = getStorage('token');
    // console.log({ token });
    if (!token && to.path !== '/login') {
        next('/login');
    } else if (to.meta.permission) {
        token ? next() : next('/403');
    } else {
        if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
            Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
                confirmButtonText: '确定'
            });
        } else {
            next();
        }
    }
});
// Vue.use(
//     new VueSocketIO({
//         debug: true,
//         connection: SocketIO('ws://192.168.0.102:8383')
//         // extraHeaders: {
//         //     'Access-Control-Allow-Credentials': true
//         // },
//         // allowEIO3: true
//         // vuex: {
//         //     store,
//         //     actionPrefix: 'SOCKET_',
//         //     mutationPrefix: 'SOCKET_'
//         // },
//         // options: { path: "/my-app/" } //Optional options
//     })
// );
new Vue({
    router,
    store,
    render: (h) => h(App)
}).$mount('#app');
